import { render } from "./dir.vue?vue&type=template&id=1ab0ae06"
import script from "./dir.vue?vue&type=script&lang=js"
export * from "./dir.vue?vue&type=script&lang=js"

import "./dir.vue?vue&type=style&index=0&id=1ab0ae06&lang=css"

import exportComponent from "E:\\newwww\\shared_space\\shared_agency\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__